import { styled } from '@mui/material/styles'

export const SummaryContainer = styled('div', {
  name: 'SummaryContainer',
  slot: 'Root',
  skipSx: true,
})`
  min-width: 345px;
  min-height: 405px;

  @media (max-width: 1000px) {
    width: 573px;
  }
`
